import api from "../services/api";
import { eStepTroca, ISearchRequest, ISearchResponse, ITroca } from "../interfaces";

export interface ITrocaListModel {
    id: string;
    representante: string;
    revendedor: string;
    categoria: string;
    produto: string;
    step: eStepTroca;
    data: string;
}

interface ITrocaResponse {
    troca: ITroca;
    message: string;
}

class ExchangeRepository {
    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<ITrocaListModel>> => {
        const response = await api.get<ISearchResponse<ITrocaListModel>>("troca", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });
        return response.data;
    }

    public Insert = async (data: FormData): Promise<ITrocaResponse> => {
        const response = await api.post<ITrocaResponse>("troca", data);
        return response.data;
    }

    public Update = async (id: string, data: FormData): Promise<ITrocaResponse> => {
        const response = await api.put<ITrocaResponse>(`troca/${id}`, data);
        return response.data;
    }

    public GetById = async (id: string): Promise<ITroca> => {
        const response = await api.get<ITroca>(`troca/${id}`);
        return response.data;
    }
    public Delete = async (id: string): Promise<void> => {
        await api.delete(`troca/${id}/deletar`);
    }
}

const exchangeRepository = new ExchangeRepository();
export default exchangeRepository;
